import { clamp } from 'lodash'

export const SCORES = [
	{ level: 4, description: 'Beyond' },
	{ level: 3, description: 'Proficient' },
	{ level: 2, description: 'Progressing' },
	{ level: 1, description: 'Beginning' },
]

export const translateScore: (?number) => ?number = (num: ?number) => {
	if (num == null) return null
	const percentageScores = [0, 50, 80, 95]
	const proficiencyScores = [1, 2, 3, 4]
	const index = percentageScores.findIndex(
		(baseline, i, list) =>
			(i + 1 === list.length || num < list[i + 1]) && num >= list[i]
	)
	if (index > -1) {
		const MAX_SCORE = 100
		// 1, 2, 3, or 4
		const proficiencyBase = proficiencyScores[index]
		const percentageBase = percentageScores[index]
		// Convert percentage excess to decimal places after the proficiency base.
		// Note: It could be possible for a student to score a 5 proficiency if their score is >=100.
		const baselinePercentageDiff =
			(percentageScores[index + 1] ?? MAX_SCORE) - percentageBase
		const scorePercentageDiff = Math.min(num, MAX_SCORE) - percentageBase
		return proficiencyBase + scorePercentageDiff / baselinePercentageDiff
	}
	return null
}

/**
 * Gets an integer between 1 and 4 to represent a student's score.
 * @param {?number} exactProficiency proficiency score with a decimal value.
 * @return {?number} proficiency score without decimal places. or null if the exact proficiency is null
 */
export const getBaseProficiency: (?number) => number | null = (
	exactProficiency: ?number
) => {
	if (exactProficiency) {
		return clamp(Math.floor(exactProficiency), 1, 4)
	}
	return null
}
